import { TypedUseSelectorHook, useSelector } from "react-redux";
import {
  getListeGarantiesSelectedProgramme,
  getSelectedProgramme,
} from "../../../redux/ProgrammeRedux";
import { RootState } from "../../../redux/reducers";
import {
  buildGarantiesAssistance,
  buildGarantiesAssurance,
  buildGarantiesInformations,
} from "../AvantageTab/helpers";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

export interface TabItem {
  index: number;
  title: string;
  value: string;
}
export const useAvantage = () => {
  const listeGaranties = useReduxSelector((state) =>
    getListeGarantiesSelectedProgramme(state)
  );
  const selectedProgramme = useReduxSelector((state) =>
    getSelectedProgramme(state)
  );
  const assistance = listeGaranties && buildGarantiesAssistance(listeGaranties);
  const assurance = listeGaranties && buildGarantiesAssurance(listeGaranties);
  const informations =
    listeGaranties && buildGarantiesInformations(listeGaranties);

  return { selectedProgramme, assistance, assurance, informations };
};
